import { createFileRoute } from '@tanstack/react-router';
import { ProgressView } from '../../features/progress/ProgressView.js';
import { boardQueryOptions, useBoard } from '../../features/board/useBoardQuery.js';

/**
 * The progress view for one board.
 *
 * A sibling route rather than a child of `/board/$boardId`, so it does not
 * inherit the board's filter search-params — the numbers here are about the
 * whole board, and showing a "62% complete" that silently excluded filtered-out
 * cards would be worse than useless.
 *
 * It reads the same cache entry the board does, keyed by the same route param,
 * so switching tabs costs nothing and live SSE updates move both views at once.
 */
export const Route = createFileRoute('/_authed/progress/$boardId')({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(boardQueryOptions(params.boardId)),
  component: ProgressRoute,
});

function ProgressRoute() {
  const { boardId } = Route.useParams();
  const { data: board } = useBoard(boardId);

  return <ProgressView board={board} cacheId={boardId} />;
}
